@import "./../../less/variables.less";

.logoDigipost {
  display: none;
  height: 45px;
  margin: 14px 28px 14px 0;
  width: auto;

  @media @dds-breakpoint-tablet-landscape-up {
    display: block;
  }
}

.logoDigipostMobil {
  display: block;
  height: 45px;
  margin: 0 var(--dds-spacing-small-4) 0 19px;

  @media @dds-breakpoint-tablet-landscape-up {
    display: none;
  }
}

.headerLogoLink {
  display: flex;
  align-items: center;
}
